module.exports = __webpack_public_path__ + "img/big.ac8e7aa2.jpg";